// Client Dashboard Action Types
export const UPDATE_SELECTED = "UPDATE_SELECTED";
export const UPDATE_SELECTED_TEMP = "UPDATE_SELECTED_TEMP";
export const UPDATE_START_DATE = "UPDATE_START_DATE";
export const UPDATE_ANALYTICS = "UPDATE_ANALYTICS";
export const TOGGLE_DROPDOWN = "TOGGLE_DROPDOWN";
export const LOAD_CLIENT_CAMPAIGNS = "LOAD_CLIENT_AMPAIGNS";
export const SET_BOXI_MAP = "SET_BOXI_MAP";
export const UPDATE_CAMPAIGN_VEHICLES = "UPDATE_CAMPAIGN_VEHICLES";
export const UPDATE_CAMPAIGN_VEHICLES_TEMP = "UPDATE_CAMPAIGN_VEHICLES_TEMP";
export const UPDATE_CAMPAIGN_ANALYTICS = "UPDATE_CAMPAIGN_ANALYTICS";
export const UPDATE_USER = "UPDATE_USER";
export const RESET_APP = "RESET_APP";
export const RESET_CLIENT_DASHBOARD = "RESET_CLIENT_DASHBOARD";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_CAMPAIGN_VEHICLES_MAPBOX = 'UPDATE_CAMPAIGN_VEHICLES_MAPBOX';

export const RESET_CAMPAIGN_VEHICLES_MAPBOX = 'RESET_CAMPAIGN_VEHICLES_MAPBOX';

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const UPDATE_INITIAL_CLICK = "UPDATE_INITIAL_CLICK";

export const UPDATE_SELECTED_TRUCKLIST = "UPDATE_SELECTED_TRUCKLIST"